/**
 * What is a minimum fresh delay,
 * when user is very active?
 */
export const minRefreshDelayTime = 2000; // 2s

/**
 * What is a maximum refresh delay,
 * for the time we treat user as active?
 */
export const maxRefreshDelayTime = 6000; // 6s

/**
 * After what inactivity time (in milliseconds),
 * we stop fetching the RPR.
 */
export const maxInactivityTime = 5 * 60 * 1000; // 5 min

/**
 * The same, but while the user is part-way through a hand-off to their phone.
 *
 * The idle tracker only wakes on desktop input -- mousemove, mousedown, click, touchstart,
 * keypress, scroll. A hand-off produces none of those: the user works on their phone for the
 * whole capture, so the desktop looks idle for exactly as long as the feature is working. At
 * the ordinary limit it would stop polling mid-capture and never learn the upload finished,
 * stranding the user on "Waiting for your upload" until they happen to move the mouse.
 *
 * Still bounded, so a genuinely abandoned hand-off stops polling too, just later.
 */
export const maxHandoffInactivityTime = 20 * 60 * 1000; // 20 min
